<template>
  <li class="md-list-item" :class="classes">
    <div class="md-list-item-container md-button">
      <slot></slot>
    </div>

    <md-button type="button" class="md-button-ghost" :disabled="disabled || null"></md-button>
  </li>
</template>

<script lang="ts">
export default {
}
</script>
<script setup lang="ts">
  import { computed } from 'vue';
  import MdButton from '../mdButton/mdButton.vue';

  const props = defineProps<{
    disabled?: Boolean
  }>()

  const classes = computed(() => {
    return {
      'md-disabled': props.disabled
    };
  });

</script>
